module.exports = __webpack_public_path__ + "static/media/info_empresas.a8786991.svg";